import React, { useRef, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Form, Input, Button, message } from "antd";
import {
  UserOutlined,
  MailOutlined,
  ApartmentOutlined,
  PhoneOutlined,
  EnvironmentOutlined,
  LockOutlined,
} from "@ant-design/icons";
import PhoneInput from "react-phone-input-2";
import logo from "../../../Assets/Images/Logo.svg";
import "./style.css";
import { registerUser } from "../../../API/userProfile";

const CreateAccount = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onFinish = async (values) => {
    try {
      setLoading(true);
      const response = await registerUser(values);
      if (Math.floor(response?.status / 100) === 2) {
        message.success(
          "Account created successfully! Please check your email to verify"
        );
        navigate("/login");
      } else {
        message.error(response?.data?.errors);
      }
    } catch (error) {
      message.error("Failed to fetch dashboard data Email Volume.");
    } finally {
      setLoading(false);
    }
  };
  const handleLoginClick = () => {
    navigate("/login");
  };

  return (
    <div className="create">
      <div className="create-page">
        <div className="logo">
          <img src={logo} alt="logo" />
        </div>

        <div className="create-card">
          <div className="content-heading">Create account</div>
          <div className="sub-heading">
            Start integration our high-performance Email APIs in minutes.
          </div>

          <Form
            name="register"
            layout="vertical"
            autoComplete="off"
            onFinish={onFinish}
          >
            <Form.Item
              label="Full Name"
              name="name"
              rules={[
                { required: true, message: "Please enter your full name!" },
              ]}
            >
              <Input
                placeholder="Enter your full name"
                prefix={<UserOutlined />}
              />
            </Form.Item>

            <Form.Item
              label="Email Address"
              name="email"
              rules={[
                { required: true, message: "Please enter your email!" },
                { type: "email", message: "Enter a valid email!" },
              ]}
            >
              <Input
                placeholder="Enter your email address"
                prefix={<MailOutlined />}
              />
            </Form.Item>

            <div style={{ display: "flex", gap: "16px" }}>
              <Form.Item
                label="Company Name"
                name="company_name"
                style={{ flex: 1 }}
                rules={[{ required: true, message: "Enter company name!" }]}
              >
                <Input
                  placeholder="Company name"
                  prefix={<ApartmentOutlined />}
                />
              </Form.Item>

              <Form.Item
                label="Phone Number"
                name="phone_number"
                style={{ flex: 1 }}
                rules={[{ required: true, message: "Enter phone number!" }]}
              >
                <PhoneInput country={"us"} />
              </Form.Item>
            </div>

            <Form.Item
              label="Business Address"
              name="business_address"
              rules={[{ required: true, message: "Enter business address!" }]}
            >
              <Input
                placeholder="Enter business address"
                prefix={<EnvironmentOutlined />}
              />
            </Form.Item>

            <div style={{ display: "flex", gap: "16px" }}>
              <Form.Item
                label="Password"
                name="password"
                style={{ flex: 1 }}
                rules={[{ required: true, message: "Enter password!" }]}
              >
                <Input.Password
                  placeholder="Password"
                  prefix={<LockOutlined />}
                />
              </Form.Item>

              <Form.Item
                label="Confirm Password"
                name="confirm_password"
                style={{ flex: 1 }}
                dependencies={["password"]}
                rules={[
                  { required: true, message: "Confirm your password!" },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue("password") === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        new Error("Passwords do not match")
                      );
                    },
                  }),
                ]}
              >
                <Input.Password
                  placeholder="Confirm password"
                  prefix={<LockOutlined />}
                />
              </Form.Item>
            </div>

            <Button
              type="primary"
              htmlType="submit"
              className="submit-button"
              loading={loading}
            >
              Create Your Account
            </Button>
          </Form>
        </div>
        <div className="bottom-info">
          Already have an account?{" "}
          <span className="login-link" onClick={handleLoginClick}>
            Login
          </span>
        </div>
      </div>
    </div>
  );
};

export default CreateAccount;
